let i = 0;

export const getRequestId = () => {
  i = i + 1;
  return i;
};
